<template>
  <el-dialog class="supplier-dialog" title="新增供应商" :visible.sync="dialogVisible" width="900px" top="8vh" :close-on-click-modal="false" :before-close="onClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="单位名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位类型" prop="companyType">
            <el-select v-model="form.companyType" placeholder="请选择" style="width: 100%">
              <el-option label="分公司" value="分公司" />
              <el-option label="客户" value="客户" />
              <el-option label="个人" value="个人" />
              <el-option label="其他" value="其他" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法人" prop="charge">
            <el-input v-model="form.charge" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="form.address" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票名称" prop="kaipiaoName">
            <el-input v-model="form.kaipiaoName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纳税人识别号" prop="nashuiNumber">
            <el-input v-model="form.nashuiNumber" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票地址电话" prop="kaipiaoAddress">
            <el-input v-model="form.kaipiaoAddress" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="form.bank" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户账号" prop="bankNumber">
            <el-input v-model="form.bankNumber" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12" title="营业执照复印件盖公章">
          <el-form-item label="营业执照附件" prop="yingyeFile">
            <el-upload
              :action="uploadUrl"
              :headers="uploadHeaders"
              :limit="1"
              :data="{
                datasourceId: '2074052553611415552',
                asImage: false,
                fieldName: 'yingye_file'
              }"
              name="uploadFile"
              :file-list="fileList2"
              :on-success="(res, file) => onUploadSuccess(res, file, 'yingyeFile', 'fileList2')"
              :on-remove="(file) => onUploadRemove(file, 'yingyeFile', 'fileList2')">
              <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12" title="开票资料复印件盖公章">
          <el-form-item label="开票资料附件" prop="kaipiaoFile">
            <el-upload
              :action="uploadUrl"
              :headers="uploadHeaders"
              :limit="1"
              :data="{
                datasourceId: '2074052553611415552',
                asImage: false,
                fieldName: 'kaipiao_file'
              }"
              name="uploadFile"
              :on-success="(res, file) => onUploadSuccess(res, file, 'kaipiaoFile', 'fileList1')"
              :on-remove="(file) => onUploadRemove(file, 'kaipiaoFile', 'fileList1')">
              <el-button size="small" type="primary" icon="el-icon-upload2">上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button size="medium" @click="onClose">取 消</el-button>
      <el-button size="medium" type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Contract } from '@/api/contract'
import { uploadMixin } from '@/core/mixins'
import projectConfig from '@/core/config'

export default {
  mixins: [uploadMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        companyName: '',
        companyType: '',
        charge: '',
        address: '',
        legal: '',
        phone: '',
        kaipiaoName: '',
        nashuiNumber: '',
        kaipiaoAddress: '',
        bank: '',
        bankNumber: '',
        kaipiaoFile: '',
        yingyeFile: ''
      },
      fileList1: [],
      fileList2: [],
      rules: {
        companyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        charge: [
          { required: true, message: '请输入法人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        nashuiNumber: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        kaipiaoAddress: [
          { required: true, message: '请输入开票地址电话', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        bankNumber: [
          { required: true, message: '请输入开户账号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    uploadUrl() {
      return projectConfig.baseUrl + 'admin/online/onlineOperation/uploadDatasource/oaFormSupplier'
    },
    uploadHeaders() {
      return this.getUploadHeaders
    },
    uploadDataKaipiao() {
      return (file) => ({
        datasourceId: '2074052553611415552',
        asImage: file.type.startsWith('image/'),
        fieldName: 'kaipiao_file'
      })
    },
    uploadDataYingye() {
      return (file) => ({
        datasourceId: '2074052553611415552',
        asImage: file.type.startsWith('image/'),
        fieldName: 'yingye_file'
      })
    }
  },
  watch: {
    visible(val) {
      if (val) this.resetForm()
    }
  },
  methods: {
    resetForm() {
      this.form = {
        companyName: '',
        companyType: '',
        charge: '',
        address: '',
        legal: '',
        phone: '',
        kaipiaoName: '',
        nashuiNumber: '',
        kaipiaoAddress: '',
        bank: '',
        bankNumber: '',
        kaipiaoFile: '',
        yingyeFile: ''
      }
      this.fileList1 = []
      this.fileList2 = []
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    onUploadSuccess(res, file, field, listKey) {
      if (res.success) {
        this[listKey].push({
          name: file.name,
          filename: res.data.filename
        })
        this.form[field] = JSON.stringify(this[listKey])
        this.$refs.form && this.$refs.form.validateField(field)
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    onUploadRemove(file, field, listKey) {
      this[listKey] = this[listKey].filter(item => item.name !== file.name)
      this.form[field] = this[listKey].length ? JSON.stringify(this[listKey]) : ''
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField(field)
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.loading = true
        const data = {
          ...this.form,
          kaipiaoFile: this.fileList1.length ? JSON.stringify(this.fileList1) : '',
          yingyeFile: this.fileList2.length ? JSON.stringify(this.fileList2) : '',
          deletedFlag: 1
        }
        Contract.addSupplier(this, data).then(res => {
          this.loading = false
          this.$message.success('新增供应商成功')
          this.$emit('success', res)
          this.onClose()
        }).catch(() => {
          this.loading = false
        })
      })
    },
    onClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.supplier-dialog {
  ::v-deep .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
  }

  ::v-deep .el-dialog__body {
    padding: 24px 24px 0;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #eee;
  }

  .el-form-item {
    margin-bottom: 20px;
    display: flex;
  }

  ::v-deep .el-form-item__label {
    line-height: 36px;
    width: 130px !important;
    display: inline-block;
  }

  ::v-deep .el-form-item__content {
    width: calc(100% - 110px);
    line-height: 36px;
    margin-left: 12px !important;
  }
  ::v-deep .el-input {
    width: 100% !important;
    flex: 1;
    margin-left: 0 !important;
  }
  ::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
    width: 100%;
  }

  .upload-btn {
    display: flex;
    align-items: center;

    .upload-tip {
      margin-left: 12px;
      font-size: 13px;

      &.success {
        color: #67c23a;
      }

      .tip-delete {
        margin-left: 8px;
        color: #999;
        cursor: pointer;

        &:hover {
          color: #f56c6c;
        }
      }
    }
  }
}
</style>
